module.exports = __webpack_public_path__ + "static/media/avon_gradient.e620d89b.svg";